export default __webpack_public_path__ + "static/media/nickel_face.b6dc4734.png";